import React, { useRef } from "react";
import { Modal, Button } from '@prosolve/common-components-ui'
import SessionScheduleManager from '../../SessionScheduleManager/SessionScheduleManager'
// import useDataSessions from '../../../dataHooks/useDataSessions';

export default ({
  sessions = [],
  eventId,
  onClose,
  onSuccess,
}) => {
  // const {
  //   newSessions,
  //   updateSessions,
  //   deleteSessions
  // } = useDataSessions();

  const sessionScheduleManagerRef = useRef()

  const onClickSubmit = async () => {

    const nonNewSessionsData = sessionScheduleManagerRef.current.getAllNonNewSessions();
    const newSessionsData = sessionScheduleManagerRef.current.getNewSessions();

    const allSessionsData = [...nonNewSessionsData, ...newSessionsData]

    // Undue helper _id and delete from session data before save
    allSessionsData.forEach(session => {
      if (session._id) {
        delete session._id
      }
    });

    onSuccess(allSessionsData)
  }

  // Session blueprint data does not have a _id so we need to make a temporary one to play nice with the scheduling componenet
  const processSessions = (sessions) => {
    let idInc = 0;
    return sessions.map(session => {
      idInc++;
      return {
        ...session,
        _id: `existing-${idInc}`
      }
    })
  }

  const footer = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button onClick={onClickSubmit} $colored={true}>
        {'Confirm'}
      </Button>
    </div>
  )

  return (
    <Modal title='Edit Schedule' isFullScreen={true} onClose={onClose} footer={footer}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '15px',
        height: '100%',
        position: 'relative'
      }}>
        <SessionScheduleManager
          ref={sessionScheduleManagerRef}
          sessions={processSessions(sessions)}
          eventId={eventId}
        />
      </div>
    </Modal>
  )
}